var _clipPath, _g, _clipPath2, _clipPath3, _clipPath4, _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer6Day(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3001 1067",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer-6",
    serifId: "layer 6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "city-3",
    serifId: "city 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1687.7,448.761c0,-1.42 -0.553,-2.783 -1.541,-3.801c-2.932,-3.02 -9.27,-9.547 -12.088,-12.449c-0.894,-0.921 -2.122,-1.44 -3.406,-1.44c-3.987,-0 -12.871,-0 -16.947,-0c-1.347,-0 -2.632,0.573 -3.532,1.575c-2.672,2.975 -8.43,9.386 -11.089,12.346c-0.899,1.001 -1.397,2.3 -1.397,3.646c0,10.294 0,55.732 0,71.556c0,3.013 2.443,5.456 5.457,5.456c9.616,-0 29.471,-0 39.087,-0c3.014,-0 5.456,-2.443 5.456,-5.456c0,-15.762 0,-60.907 0,-71.433Z",
    style: {
      fill: "#cff4e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.04,475.483c-0,-3.013 -2.443,-5.456 -5.456,-5.456c-5.217,0 -13.038,0 -18.255,0c-3.013,0 -5.456,2.443 -5.456,5.456c0,14.473 0,53.718 0,68.19c0,3.014 2.443,5.457 5.456,5.457c5.217,-0 13.038,-0 18.255,-0c3.013,-0 5.456,-2.443 5.456,-5.457c-0,-14.472 -0,-53.717 -0,-68.19Z",
    style: {
      fill: "#cff4e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1709.71,440.58c-0.34,-1.48 -1.658,-2.53 -3.177,-2.53c-1.519,0 -2.837,1.049 -3.177,2.53c-3.68,15.041 -9.242,39.957 -9.242,53.123c-0,12.211 5.564,22.125 12.419,22.125c6.854,0 12.419,-9.914 12.419,-22.125c0,-13.166 -5.562,-38.082 -9.242,-53.123Z",
    style: {
      fill: "#cff4e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1728.34,418.875c-0.391,-1.411 -1.675,-2.387 -3.14,-2.388c-1.464,0 -2.748,0.977 -3.14,2.388c-4.286,14.728 -11.443,41.383 -11.443,55.165c0,12.212 6.535,22.126 14.583,22.126c8.049,-0 14.584,-9.914 14.584,-22.126c-0,-13.782 -7.157,-40.437 -11.444,-55.165Z",
    style: {
      fill: "#cff4e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "trees-5",
    serifId: "trees 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2490.84,241.792c-0.391,-1.411 -1.675,-2.388 -3.14,-2.388c-1.464,0 -2.748,0.977 -3.14,2.388c-4.286,14.728 -11.443,41.383 -11.443,55.165c0,12.211 6.535,22.125 14.583,22.125c8.049,0 14.584,-9.914 14.584,-22.125c-0,-13.782 -7.157,-40.437 -11.444,-55.165Z",
    style: {
      fill: "#c1f5f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2515.79,210.086c-0.451,-1.318 -1.69,-2.204 -3.083,-2.204c-1.393,-0 -2.632,0.885 -3.082,2.204c-5.322,15.092 -15.668,46.46 -15.668,62.219c0,13.169 8.402,23.861 18.75,23.861c10.349,-0 18.75,-10.692 18.75,-23.861c0,-15.759 -10.345,-47.127 -15.667,-62.219Z",
    style: {
      fill: "#c1f5f8"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M131.345,91.846c-0.483,-0.207 -1.03,-0.205 -1.512,0.006c-0.481,0.21 -0.854,0.61 -1.031,1.105c-2.258,6.347 -9.455,26.574 -10.965,30.817c-0.185,0.52 -0.28,1.068 -0.28,1.62c-0,6.067 -0,43.194 -0,43.194c-0,0 25.51,-0.034 36.764,-0.049c1.348,-0.002 2.633,-0.566 3.546,-1.557c0.913,-0.991 1.371,-2.318 1.263,-3.661c-1.266,-15.737 -4.963,-61.702 -4.963,-61.702c-0,-0 -17.074,-7.312 -22.822,-9.773Z",
    style: {
      fill: "#bef6fd"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.345,91.846c-0.483,-0.207 -1.03,-0.205 -1.512,0.006c-0.481,0.21 -0.854,0.61 -1.031,1.105c-2.258,6.347 -9.455,26.574 -10.965,30.817c-0.185,0.52 -0.28,1.068 -0.28,1.62c-0,6.067 -0,43.194 -0,43.194c-0,0 25.51,-0.034 36.764,-0.049c1.348,-0.002 2.633,-0.566 3.546,-1.557c0.913,-0.991 1.371,-2.318 1.263,-3.661c-1.266,-15.737 -4.963,-61.702 -4.963,-61.702c-0,-0 -17.074,-7.312 -22.822,-9.773Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.124,137.246c-0,-0.963 -0.383,-1.887 -1.064,-2.568c-0.681,-0.68 -1.604,-1.063 -2.567,-1.063c-0.807,-0 -1.662,-0 -2.469,-0c-0.963,-0 -1.886,0.383 -2.567,1.063c-0.681,0.681 -1.064,1.605 -1.064,2.568c0,5.838 0,17.245 0,23.083c0,0.963 0.383,1.886 1.064,2.567c0.681,0.681 1.604,1.064 2.567,1.064c0.807,-0 1.662,-0 2.469,-0c0.963,-0 1.886,-0.383 2.567,-1.064c0.681,-0.681 1.064,-1.604 1.064,-2.567c-0,-5.838 -0,-17.245 -0,-23.083Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image3",
    x: 152.503,
    y: 136.5,
    width: "9.73px",
    height: "30.345px",
    transform: "matrix(0.97305,0,0,0.978863,0,0)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M150,89.751c0,-1.632 -1.323,-2.954 -2.954,-2.954c-0.002,-0 -0.003,-0 -0.005,-0c-1.631,-0 -2.954,1.322 -2.954,2.954c0,4.709 0,13.393 0,13.393l5.913,-0c0,-0 0,-8.684 0,-13.393Z",
    style: {
      fill: "#bef6fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.572,84.676c0.794,-0.765 1.902,-1.112 2.991,-0.937c1.089,0.175 2.032,0.852 2.547,1.827c4.817,9.118 16.155,30.58 18.801,35.591c0.368,0.695 0.56,1.47 0.56,2.256c-0,6.971 -0,42.012 -0,42.012l-58.793,0c-2.654,0 -4.811,-2.14 -4.831,-4.793c-0.073,-9.37 -0.231,-29.77 -0.282,-36.332c-0.01,-1.326 0.526,-2.599 1.482,-3.519c6.062,-5.832 28.869,-27.776 37.525,-36.105Z",
    style: {
      fill: "#bef6fd"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.572,84.676c0.794,-0.765 1.902,-1.112 2.991,-0.937c1.089,0.175 2.032,0.852 2.547,1.827c4.817,9.118 16.155,30.58 18.801,35.591c0.368,0.695 0.56,1.47 0.56,2.256c-0,6.971 -0,42.012 -0,42.012l-58.793,0c-2.654,0 -4.811,-2.14 -4.831,-4.793c-0.073,-9.37 -0.231,-29.77 -0.282,-36.332c-0.01,-1.326 0.526,-2.599 1.482,-3.519c6.062,-5.832 28.869,-27.776 37.525,-36.105Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.249,124.946c-0.004,-0.463 -0.118,-0.917 -0.333,-1.327c-1.89,-3.603 -11.435,-21.795 -14.249,-27.159c-0.156,-0.297 -0.462,-0.485 -0.798,-0.491c-0.336,-0.005 -0.648,0.173 -0.813,0.465c-3.032,5.353 -13.446,23.737 -15.557,27.464c-0.246,0.434 -0.375,0.924 -0.375,1.423c-0,5.591 -0,40.104 -0,40.104l32.473,-0.006c0,0 -0.301,-35.042 -0.348,-40.473Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.55
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.408,69.912c0.408,0.665 1.132,1.071 1.912,1.071c0.781,-0 1.505,-0.406 1.913,-1.071c3.873,-6.116 12.281,-20.192 12.281,-27.139c-0,-7.548 -6.36,-13.676 -14.194,-13.676c-7.833,-0 -14.193,6.128 -14.193,13.676c-0,6.947 8.407,21.023 12.281,27.139Z",
    style: {
      fill: "#bef6fd"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.408,69.912c0.408,0.665 1.132,1.071 1.912,1.071c0.781,-0 1.505,-0.406 1.913,-1.071c3.873,-6.116 12.281,-20.192 12.281,-27.139c-0,-7.548 -6.36,-13.676 -14.194,-13.676c-7.833,-0 -14.193,6.128 -14.193,13.676c-0,6.947 8.407,21.023 12.281,27.139Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.111,39.375c-1.509,1.509 -1.509,3.956 -0,5.465c1.509,1.508 3.955,1.508 5.464,-0l2.691,-2.691c0.274,-0.275 0.719,-0.275 0.993,-0c0.274,0.274 0.274,0.719 0,0.994l-1.934,1.934c1.518,1.267 3.779,1.188 5.204,-0.237c1.51,-1.509 1.51,-3.956 0,-5.465c-1.508,-1.509 -3.955,-1.509 -5.464,0l-2.69,2.691c-0.274,0.274 -0.719,0.274 -0.994,0c-0.274,-0.274 -0.274,-0.719 -0,-0.993l1.934,-1.935c-1.518,-1.267 -3.779,-1.188 -5.204,0.237Zm6.21,-1.226c-2.07,-1.822 -5.227,-1.744 -7.204,0.233c-2.057,2.058 -2.057,5.393 0,7.451c1.977,1.977 5.134,2.054 7.204,0.233c2.069,1.821 5.226,1.744 7.202,-0.233c2.057,-2.058 2.057,-5.393 0,-7.451c-1.976,-1.977 -5.133,-2.055 -7.202,-0.233Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "mountains-5",
    serifId: "mountains 5",
    d: "M0,101.906c0,0 146.058,66.566 206.25,60.642c68.912,-6.782 103.467,-169.737 193.75,-147.013c120.43,30.312 137.251,281.702 269.792,365.715c55.804,35.373 82.461,-64.711 159.375,-47.917c115.542,25.229 195.228,308.785 438.541,318.75c259.54,10.631 386.165,-204.459 552.084,-214.762c147.693,-9.172 268.531,162.27 406.933,99.823c175.787,-79.314 323.648,-373.623 412.858,-396.719c103.805,-26.874 115.709,147.665 187.364,132.086c116.276,-25.281 173.053,-272.511 173.053,-272.511l-0,1066.98l-3000,0l-0.002,-965.072Z",
    style: {
      fill: "url(#_Linear6)",
      fillRule: "nonzero"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,101.906c0,0 146.058,66.566 206.25,60.642c68.912,-6.782 103.467,-169.737 193.75,-147.013c120.43,30.312 137.251,281.702 269.792,365.715c55.804,35.373 82.461,-64.711 159.375,-47.917c115.542,25.229 195.228,308.785 438.541,318.75c259.54,10.631 386.165,-204.459 552.084,-214.762c147.693,-9.172 268.531,162.27 406.933,99.823c175.787,-79.314 323.648,-373.623 412.858,-396.719c103.805,-26.874 115.709,147.665 187.364,132.086c116.276,-25.281 173.053,-272.511 173.053,-272.511l-0,1066.98l-3000,0l-0.002,-965.072Z",
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.581,160.098c34.752,8.264 88.356,21.358 51.558,46.609c-13.462,9.238 3.285,29.049 41.609,40.448c70.688,21.024 188.514,29.278 192.653,37.292c6.989,13.532 -50.567,18.835 -29.366,47.2c11.311,15.133 127.731,46.782 201.82,52.979c-13.003,-7.368 -28.094,-20.621 -28.094,-20.621c-51.393,-9.708 -158.356,-30.131 -158.556,-45.559c-0.199,-15.285 62.345,-24.976 24.093,-44.112c-32.945,-16.482 -260.882,-33.999 -220.481,-70.718c22.997,-20.901 -9.846,-36.981 -70.159,-51.477l-5.077,7.959Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.27
    }
  })))), /*#__PURE__*/React.createElement("defs", null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_Image3",
    width: "10px",
    height: "31px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAfCAYAAADeKVyVAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADE0lEQVQ4jT2UOY7cSBBFXy5M7qylq3oxBMjS7eYCA8gba+w5nyxBqha6urhkMrklOUa1dID4iP9+/BDTf/9s0cMD7udP8t0OloVhGJjnGSEExhjiv74Kua4r/eVCnucM1tK2LUmSsK4rSim2bQNAa60xxkAUoeaZYRhwzvHy5QvL7YZSCgCpjGGeZ9ZxxHvPtm08Pj4yXa8IIRBC3BWXcWQYBpRSVKcTpm1RWjMMAyZJWJflrvh7Ko5jhrYlORywXUe+3wNQ1zX1v39vclkWyt0OKSVJkoD3FFVF8/ZGmGeMMRRFgXTOgRC0bUvf91hrIY6pqoqmaZBSMk0T8ng+gxBorem6Du89aM3lciFJEpZlIc0yNOtK2zRUpxN5nuOcY7peeX5+RhhD3zQ4a9H17YYxhu56RSmFUorlw6m93SjLEiklMssy4jimPJ8xxpDudoQQsNZy/PwZKSV1XSPN4YAQguAc0zQxdh193xNFEfP1SgiBNE2Rr9++sW0b27ahtUZrTVEUKKXo+57xIxD99PIC20ZT1yiliOOYOI7RWQZRxHS73Tl3TQMfh1GUJSEE1nWlr2u6ywWtNbfrFV2WJaO1pFmG7TriOCYyBikl2hgQgsPDA9J7T1wUbOtKsduxLAuD9/R9zzJNdHUN24YMIRCGASElrm3x3pPs91SHw581tnVFFk9Pd8jzTJIkRFHE2DQACCHIsuye9fj+zjRNaK1p25bydMI5xzKORFFElGUIIZBaa0ye/1G4XS7EcYz3HpFl+LbFJAnaOUel1L0O64oxhrwoIE2pf/wgz3NIEnS124GURMDxfIYQCMuC8p794QB5Tv/rF9J2HSgFWcY8DPR9j5QSlGINAXu53D30fU+x23F7feVwPCKlJISAWFeU1hRlCcag9/s9YZo4HI/MH+6FMYRhYBpHrLVorZHtRz1t12GtRaQpaI2UkqZpSNP0fman52d653DOUVUVb9+/AzAMA+fzmRAC3nuk7zoAnj59YhxHsizDv7//Yfk7RjnPM1mew7qSJAnOuftnkPLO9COM/wHaqa5J6tuDJwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.5833,1392.55,-2072.89,21.7081,1556.25,43.5708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bdf6ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffed89",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer6Day);
export default __webpack_public_path__ + "static/media/layer6-day.821a232ce37301abaca30ad1c7ebc04d.svg";
export { ForwardRef as ReactComponent };